export const mapAssetSrc = (src) => {
  if (process.env.REACT_APP_LOCAL_FILES) {
    const assets = require("assets.json");
    if (assets) {
      const imgSrcs = assets.imgSrcs;
      const val = imgSrcs.find((item) => item.url === src);
      if (val?.aliasName) return "/assets/" + val.aliasName;
    }
  }
  return src;
};
